import React, { useContext, useEffect, useState } from 'react'
import Container from '../../components/Container/Container';
import Body from '../../components/Body/Body';
import { CartContext } from "../../context/CartContext";
import './Cart.css'
import CheckoutModal from '../../components/CheckoutModal/CheckoutModal';
import VoucherSelector from '../../components/VoucherSelector/VoucherSelector';
import { AuthContext } from '../../context/AuthContext';
import OrderManagement from '../AdminManager/OrderManagement';
import HistoryCart from './HistoryCart';
export const Cart = () => {
  const { userData } = useContext(AuthContext);

  useEffect(() => {
    console.log("Check userData--------->", userData)
  }, [userData])


  const { cart, removeFromCart, updateQuantity, setCart } = useContext(CartContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [view, setView] = useState("cart")

  // Tính tổng tiền
  const totalPrice = cart.reduce((total, item) => total + item.price * item.quantity, 0);
  const noImg = 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
  const url_img = 'https://matmasocaivan.com/MMS_data/'
  // console.log("Sản phẩm trong giỏ hàng---->", cart)


  const getHighestShipCost = (cart) => {
    if (cart.length === 0) return 0;
    return Math.max(...cart.map(item => item.ship_cost.Cost));
  };

  const highestShipCost = getHighestShipCost(cart);


  const calculateTotalPrice = (totalPrice, discount, highestShipCost) => {
    const discountAmount = discount ? (totalPrice * discount / 100) : 0;
    return totalPrice - discountAmount + highestShipCost;
  };

  const totalAmount = calculateTotalPrice(totalPrice, selectedVoucher?.discount, highestShipCost);


  const clearCart = () => {
    setCart([]);
  };



  return (
    <Container>

<Body>
      <div className="cart-box">
        <div className="cart-header">
          <h2 onClick={() => setView('cart')} style={{ cursor: 'pointer' }}>🛒 Giỏ hàng</h2>
          <h2 onClick={() => setView('history')} style={{ cursor: 'pointer' }}>🛒 Lịch sử mua hàng</h2>
        </div>
        {view === 'cart' ? (
          <>
            <table className="cart-table">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Sản Phẩm</th>
                  <th>Giá</th>
                  <th>Số Lượng</th>
                </tr>
              </thead>
              <tbody>
                {cart.length > 0 ? (
                  cart.map((item, index) => (
                    <tr key={item.ID}>
                      <td>{index + 1}</td>
                      <td className="cart-item">
                        <img src={item.picture_url ? (url_img + item.picture_url) : noImg} alt="" className="cart-item-img" />
                        <span style={{ marginLeft: 20 }}>{item.product_name}</span>
                      </td>
                      <td>{item.price.toLocaleString()}đ</td>
                      <td className="cart-quantity">
                        <input
                          type="number"
                          value={item.quantity}
                          min="1"
                          onChange={(e) => updateQuantity(item.ID, parseInt(e.target.value))}
                        />
                        <button className="remove-btn" onClick={() => removeFromCart(item.ID)}>Xóa</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">Giỏ hàng trống</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="cart-footer">
              <h3>Ưu đãi: {selectedVoucher ? `Giảm ${selectedVoucher.discount}% - Mã ${selectedVoucher.VoucherCode}` : "Chưa chọn"}</h3>
              <VoucherSelector onSelectVoucher={setSelectedVoucher} userData={userData} />
            </div>
            <div className="cart-footer">
              <h3>Phí vận chuyển: {highestShipCost.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</h3>
            </div>
            <div className="cart-footer">
              <h3>Tổng Cộng: {totalAmount.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</h3>
              <button onClick={() => setIsModalOpen(true)} className="btn-pay">Thanh Toán</button>
            </div>
            <CheckoutModal
              visible={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              selectedVoucher={selectedVoucher}
              cart={cart}
              price={totalAmount}
              clearCart={clearCart}
              userData={userData}
            />
          </>
        ) : (
          <HistoryCart userData={userData} /> // Hiển thị component quản lý đơn hàng
        )}
      </div>
    </Body>
    </Container>
  )
}

export default Cart;
